import { render, staticRenderFns } from "./JobBfixTable.vue?vue&type=template&id=3c5925ce&scoped=true"
import script from "./JobBfixTable.vue?vue&type=script&lang=ts"
export * from "./JobBfixTable.vue?vue&type=script&lang=ts"
import style0 from "./JobBfixTable.scss?vue&type=style&index=0&id=3c5925ce&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5925ce",
  null
  
)

export default component.exports